export const pushPageView = () => {
    window.dataLayer.push({event: 'gtm.track.view', page: document.title });
}


// WEBPACK FOOTER //
// ./src/utils/tracking/customGtm.js